export default 'https://tme.understood.org/assets/spider-top.9d47e449.lottie'